import moment from 'moment';

const todayDateTime = moment().startOf('day').toISOString();
const yesterdayDateTime = moment().subtract(1, 'days').startOf('day').toISOString();
const lastSevenDayDateTime = moment().subtract(6, 'days').startOf('day').toISOString();
const startMonthDateTime = moment().startOf('month').toISOString();
const endMonthDateTime = moment().endOf('month').toISOString();

export const dateFilterOptions = {
  all: { startDateTime: new Date(0), endDateTime: new Date() },
  today: { startDateTime: todayDateTime, endDateTime: todayDateTime },
  yesterday: { startDateTime: yesterdayDateTime, endDateTime: yesterdayDateTime },
  lastSevenDay: { startDateTime: lastSevenDayDateTime, endDateTime: todayDateTime },
  month: {
    startDateTime: startMonthDateTime,
    endDateTime: endMonthDateTime,
  },
};
